import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {FeatureToggleService} from './feature-toggle.service';

@Directive({
  selector: '[idealsFeatureToggle]',
  standalone: false
})
export class FeatureToggleDirective implements OnInit {
  @Input()
  public idealsFeatureToggle: string;

  @Input()
  public idealsFeatureToggleElse?: TemplateRef<any>;

  constructor(
    private readonly _featureToggleService: FeatureToggleService,
    private readonly _vcr: ViewContainerRef,
    private readonly _tpl: TemplateRef<any>
  ) {
  }

  public ngOnInit(): void {
    const isEnabled = this._featureToggleService.isEnabled(this.idealsFeatureToggle);

    if (isEnabled) {
      this._vcr.createEmbeddedView(this._tpl);
    } else if (this.idealsFeatureToggleElse) {
      this._vcr.createEmbeddedView(this.idealsFeatureToggleElse);
    } else {
      this._vcr.clear();
    }
  }
}
